import { render, staticRenderFns } from "./ExtBizLeaveForm.vue?vue&type=template&id=8f59bc62&scoped=true&"
import script from "./ExtBizLeaveForm.vue?vue&type=script&lang=js&"
export * from "./ExtBizLeaveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f59bc62",
  null
  
)

export default component.exports